const API_BASE_URL = 'https://marketluz.com/laravel8/public/api';

export const fetchProducts = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/productos-con-stock`);
    const data = await response.json();
    return data.data || [];
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};
